import { COMMAND_ACK_RESPONSE } from "./commands/ACK";
import { CONTROL_IQ_COMMAND, CONTROL_IQ_RESPONSE } from "./commands/ControlIQ";
import { EVENT_COMMAND, EVENT_RESPONSE, MULTI_EVENT_COMMAND, STOP_MULTI_EVENT_COMMAND } from "./commands/Event";
import { GLOBAL_DATA_COMMAND, GLOBAL_DATA_RESPONSE } from "./commands/GlobalData";
import { LOG_SIZE_COMMAND, LOG_SIZE_RESPONSE } from "./commands/LogSize";
import { MAX_BOLUS_COMMAND, MAX_BOLUS_RESPONSE } from "./commands/MaxBolus";
import { PERSONAL_PROFILE_COMMAND, PERSONAL_PROFILE_RESPONSE } from "./commands/PersonalProfile";
import { PERSONAL_PROFILE_LIST_COMMAND, PERSONAL_PROFILE_LIST_RESPONSE } from "./commands/PersonalProfileList";
import { VERSION_COMMAND, VERSION_RESPONSE } from "./commands/Version";

export const TandemResponses = {
  [VERSION_RESPONSE.value]: VERSION_RESPONSE,
  [COMMAND_ACK_RESPONSE.value]: COMMAND_ACK_RESPONSE,
  [LOG_SIZE_RESPONSE.value]: LOG_SIZE_RESPONSE,
  [GLOBAL_DATA_RESPONSE.value]: GLOBAL_DATA_RESPONSE,
  [MAX_BOLUS_RESPONSE.value]: MAX_BOLUS_RESPONSE,
  [CONTROL_IQ_RESPONSE.value]: CONTROL_IQ_RESPONSE,
  [PERSONAL_PROFILE_LIST_RESPONSE.value]: PERSONAL_PROFILE_LIST_RESPONSE,
  [PERSONAL_PROFILE_RESPONSE.value]: PERSONAL_PROFILE_RESPONSE,
  [EVENT_RESPONSE.value]: EVENT_RESPONSE,
};

export const TandemCommands = {
  VERSION_COMMAND,
  LOG_SIZE_COMMAND,
  GLOBAL_DATA_COMMAND,
  MAX_BOLUS_COMMAND,
  CONTROL_IQ_COMMAND,
  PERSONAL_PROFILE_LIST_COMMAND,
  PERSONAL_PROFILE_COMMAND,
  MULTI_EVENT_COMMAND,
  STOP_MULTI_EVENT_COMMAND,
  EVENT_COMMAND,
};
